<template>
  <OrdersContainer />
</template>

<script lang="ts">
import Vue from "vue";
import OrdersContainer from "@/components/projects/project/house/orders/container/OrdersContainer.vue";

export default Vue.extend({
  components: {
    OrdersContainer,
  },
});
</script>
